import { ApplicationInsights } from "@microsoft/applicationinsights-web";
export * from "@microsoft/applicationinsights-web";

export var logger: ApplicationInsights;

export function init(appInsightsLogger: ApplicationInsights) {
    logger = appInsightsLogger;
}